module.exports = __webpack_public_path__ + "02_sobakasu.a3a0536f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer3/02_sobakasu.png
// module id = cKnP
// module chunks = 0